import { type FC } from "react";
import { Icon } from "@root/shared/components/Icon";
import * as styles from "./styles.css";

export type KeepButtonProps = {
  url: string;
  query?: string;
  gaAction?: string;
  gaLabel?: string;
  appierAction?: string;
  firebaseAction?: string;
  workCode: string;
  hasKeeped: boolean;
  isPreview?: boolean;
  pageType?: string;
};

export const KeepButton: FC<KeepButtonProps> = ({
  url,
  query,
  gaAction,
  gaLabel,
  appierAction,
  firebaseAction,
  workCode,
  hasKeeped,
  isPreview = false,
  pageType,
}) => {
  const isGaTagSet = gaAction && gaLabel;

  if (workCode) {
    return (
      <div className="js-bookmark-area">
        {!isPreview && (
          <>
            <form
              className="js-add-bookmark-form"
              action={url}
              acceptCharset="UTF-8"
              data-remote="true"
              method="post"
            >
              <input type="hidden" name="work[code]" value={workCode} />
              <input type="hidden" name="work[query]" value={query || ""} />
            </form>
            <form
              className="js-remove-bookmark-form"
              action={url}
              acceptCharset="UTF-8"
              data-remote="true"
              method="post"
            >
              <input type="hidden" name="_method" value="delete" />
              <input type="hidden" name="work[code]" value={workCode} />
            </form>
          </>
        )}
        <button
          type="button"
          className={`${styles.keepButton} js-btn--keep disable-on-preview
            ${firebaseAction ? "firebase-click" : ""}
            ${hasKeeped ? "is-keeped" : ""}
            ${isGaTagSet ? "ga-click" : ""}`}
          data-bookmark-status={hasKeeped ? "2" : "1"}
          data-bookmark-code={workCode}
          data-bookmark-view-type="screen_view"
          data-appier-action={appierAction}
          data-ga-action={gaAction}
          data-ga-label={gaLabel}
          data-firebase-action={firebaseAction}
          data-style-type="new"
          data-page-type={pageType || ""}
        >
          {hasKeeped ? (
            <>
              <Icon name="keep-star" />
              解除
            </>
          ) : (
            <>
              <Icon name="keep-star-outline" />
              キープする
            </>
          )}
        </button>
      </div>
    );
  }
  return (
    <button
      type="button"
      className={`${styles.keepButton} firebase-click js-contract-expired-job-keep
        ${isGaTagSet ? "ga-click" : ""}`}
      data-ga-action="shop_keep_link-top"
      data-firebase-action="keep"
      data-firebase-action-type="jump_to_job_list"
    >
      <Icon name="keep-star-outline" />
      キープする
    </button>
  );
};
